/* eslint-disable default-case */
/* eslint-disable consistent-return */
import React from 'react';
import styled, {css} from 'styled-components';

import Button, {type ButtonType, type ButtonProps} from 'web-app/react/components/form-elements/button/button';
import {s11, getSpacing} from 'web-app/styleguide/spacing';

export type Align = 'left' | 'center' | 'right';

const PopoverRow: React.FC<
    React.PropsWithChildren<{
        onClick?: () => void;
        active?: boolean;
        disabled?: boolean;
        className?: string;
        type?: ButtonType;
        alignContent?: Align;
        buttonId?: string;
        href?: string;
    }>
> = ({children, onClick, disabled, className, type, alignContent = 'left', buttonId, href}) => {
    const handleClick = e => {
        if (onClick) {
            e.stopPropagation();
            onClick();
        }
    };

    return (
        <StyledButton
            align={alignContent}
            href={href}
            type={type}
            buttonSize={'mini'}
            id={buttonId}
            className={className}
            onClick={handleClick}
            isDisabled={disabled}
        >
            <InnerRow>{children}</InnerRow>
        </StyledButton>
    );
};

export default PopoverRow;

const InnerRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

const alignPropToCss = (align: Align) => {
    switch (align) {
        case 'left':
            return css`
                &,
                ${InnerRow} {
                    justify-content: flex-start;
                }
            `;
        case 'center':
            return css`
                &,
                ${InnerRow} {
                    justify-content: center;
                }
            `;
        case 'right':
            return css`
                &,
                ${InnerRow} {
                    justify-content: flex-end;
                }
            `;
    }
};

export const StyledButton = styled(Button)<{align: Align; active?: boolean} & ButtonProps>`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    border-radius: 0;
    height: ${getSpacing(s11)};
    &,
    &:focus {
        border-color: ${props => props.theme.delimiter};
    }
    & + &,
    & + &:focus {
        border-top: none;
    }
    &:last-child {
        border-bottom: none;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    &:first-child {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }
    ${props =>
        props.active
            ? css`
                  font-weight: 500;
              `
            : ''}
    ${props => alignPropToCss(props.align)}
`;
